import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = null;

const select = (_, { payload }) => payload?.language;

export default createReducer(initialState, {
  [actionTypes.SET_SELECTED_LANGUAGE]: select,
  [actionTypes.APPLICATION_IS_READY_SUCCESS]: select,
});
